(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isManagedByGroup = false;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Check if managed by StickyGroupManager (set after manager initializes)
      // Use MutationObserver to detect when managedByGroup attribute is set
      this.checkManagedStatus();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      // Listen for sticky events from StickyGroupManager
      this.addEventListener('stickyHide', this.onManagedHide.bind(this));
      this.addEventListener('stickyReveal', this.onManagedReveal.bind(this));
      this.addEventListener('stickyReset', this.onManagedReset.bind(this));

      // Only attach scroll handler if not managed by group
      if (!this.isManagedByGroup) {
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
    }

    checkManagedStatus() {
      // Check if already managed
      if (this.dataset.managedByGroup === 'true') {
        this.isManagedByGroup = true;
        return;
      }

      // Watch for the attribute to be set by the manager
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'data-managed-by-group' && this.dataset.managedByGroup === 'true') {
            this.isManagedByGroup = true;
            // Remove scroll handler if it was attached
            if (this.onScrollHandler) {
              window.removeEventListener('scroll', this.onScrollHandler);
            }
            observer.disconnect();
          }
        });
      });

      observer.observe(this, { attributes: true });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      if (this.onScrollHandler) {
        window.removeEventListener('scroll', this.onScrollHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // Skip if managed by group
      if (this.isManagedByGroup) return;

      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    // Event handlers for when managed by StickyGroupManager
    onManagedHide() {
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    onManagedReveal() {
      // Any reveal-specific logic
    }

    onManagedReset() {
      // Any reset-specific logic
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jase-feature-reveal"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('jase-feature-reveal')) {
    customElements.define('jase-feature-reveal', class extends HTMLElement {
      connectedCallback() {
        this.initFrame = requestAnimationFrame(() => this.initialize());
      }
      initialize() {
        if (!this.isConnected || this.abort) return;
        this.range = this.querySelector('[data-range]');
        if (!this.range) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.buttons = [...this.querySelectorAll('[data-to]')];
        this.status = this.querySelector('[data-status]');
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.right = this.dataset.direction === 'right';
        this.duration = Math.max(0, Number(this.dataset.duration) || 0);
        this.range.addEventListener('input', () => {
          this.stop();
          this.draw(this.right ? 100 - Number(this.range.value) : Number(this.range.value));
        }, options);
        this.range.addEventListener('change', () => this.announce(), options);
        this.range.addEventListener('pointerdown', () => this.stop(), options);
        this.buttons.forEach(button => button.addEventListener('click', () => this.move(Number(button.dataset.to)), options));
        document.addEventListener('shopify:block:select', event => {
          if (this.contains(event.target)) {
            this.stop();
            this.draw(event.target.closest('[data-panel="benefit"]') ? 100 : 0);
          }
        }, options);
        this.reduced.addEventListener('change', () => {
          if (this.reduced.matches && this.target != null) {
            const target = this.target;
            this.stop();
            this.draw(target);
          }
        }, options);
        this.draw(Number(this.dataset.initial));
        this.classList.add('jfr--ready');
        this.alignRows();
        let previousWidth = this.clientWidth;
        this.resize = new ResizeObserver(() => {
          if (this.clientWidth !== previousWidth) {
            previousWidth = this.clientWidth;
            this.alignRows();
          }
        });
        this.resize.observe(this);
        document.fonts?.ready.then(() => { if (this.isConnected && this.abort) this.alignRows(); });
      }
      alignRows() {
        const features = [...this.querySelectorAll('[data-panel="feature"] [data-pair]')];
        const benefits = [...this.querySelectorAll('[data-panel="benefit"] [data-pair]')];
        const labels = [...this.querySelectorAll('.jfr__panel-label')];
        [...features, ...benefits, ...labels].forEach(row => { row.style.minHeight = ''; });
        const labelHeight = Math.max(0, ...labels.map(label => label.getBoundingClientRect().height));
        const heights = features.map((row, index) => Math.max(row.getBoundingClientRect().height, benefits[index]?.getBoundingClientRect().height || 0));
        labels.forEach(label => { label.style.minHeight = `${labelHeight}px`; });
        features.forEach((row, index) => {
          row.style.minHeight = `${heights[index]}px`;
          if (benefits[index]) benefits[index].style.minHeight = `${heights[index]}px`;
        });
      }
      draw(value) {
        this.value = Math.max(0, Math.min(100, Number(value) || 0));
        const physical = this.right ? 100 - this.value : this.value;
        this.style.setProperty('--jfr-position', `${this.value}%`);
        this.style.setProperty('--jfr-seam', `${physical}%`);
        this.range.value = String(physical);
        this.buttons.forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.to) === this.value)));
        this.range.setAttribute('aria-valuetext', this.value === 0 ? this.dataset.featureLabel : this.value === 100 ? this.dataset.benefitLabel : `${Math.round(this.value)}% ${this.dataset.benefitLabel}`);
      }
      stop() {
        cancelAnimationFrame(this.animation);
        this.target = null;
      }
      move(target) {
        this.stop();
        if (this.reduced.matches || !this.duration) { this.draw(target); this.announce(); return; }
        this.target = target;
        const from = this.value;
        const start = performance.now();
        const tick = now => {
          const t = Math.min(1, Math.max(0, (now - start) / this.duration));
          const eased = t === 1 ? 1 : 1 - Math.pow(2, -10 * t);
          this.draw(from + (target - from) * eased);
          if (t < 1) this.animation = requestAnimationFrame(tick);
          else { this.target = null; this.announce(); }
        };
        this.animation = requestAnimationFrame(tick);
      }
      announce() { this.status.textContent = this.range.getAttribute('aria-valuetext'); }
      disconnectedCallback() {
        cancelAnimationFrame(this.initFrame);
        this.stop();
        this.abort?.abort();
        this.resize?.disconnect();
        this.abort = null;
        this.classList.remove('jfr--ready');
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
